import styles from "../styles/Latest_projects_temp.module.css";

function LatestProjects() {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.title}>My Latest Projects</div>
      <AllProjects />
    </div>
  );
}

function AllProjects() {
  return (
    <div className={styles.allprojects}>
      <Card />
      <Card />
      <Card />
      <Card />
    </div>
  );
}

function Card() {
  return (
    <div className={styles.projectcard}>
      <img
        alt="projectImage"
        className={styles.projectimage}
        src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
      />
      <div className={styles.projectdetailscontainer}>
        <div className={styles.projectsubdescription}>UI UX Design</div>
        <div className={styles.projecttitle}>Courses Website</div>
        <div className={styles.projectdescription}>
          This website is about courses. You can signup, signin learn different
          things This website is about courses. You can signup, signin learn
          different things This website is about courses. You can signup, signin
          learn different things This website is about courses. You can sirgnup,
          signin learn different things
        </div>
        <div className={styles.projectlinktext}>View Details</div>
      </div>
    </div>
  );
}

export default LatestProjects;
